import { render, staticRenderFns } from "./BridgeMain.vue?vue&type=template&id=7546ffb2&scoped=true"
import script from "./BridgeMain.vue?vue&type=script&lang=js"
export * from "./BridgeMain.vue?vue&type=script&lang=js"
import style0 from "./BridgeMain.vue?vue&type=style&index=0&id=7546ffb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7546ffb2",
  null
  
)

export default component.exports